(function () {
    'use strict';

    angular.module("imApp").factory("labourJobNoteService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 536,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 537,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
